export enum ExtraCostType {
  ACCOUNT = 1,
  OPERATOR,
}
